import React, { useState } from "react";
import {
  Avatar,
  Button,
  TextField,
  Paper,
  Box,
  Grid,
  Typography,
  Alert,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");

  const [error, setError] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleLogin(e) {
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      if (email === "admin" && senha === "senha123") {
        sessionStorage.setItem("auth", "true");
        navigate("/admin/dashboard");
      } else {
        setError("Credenciais inválidas.");
        setOpenSnackbar(true);
      }

      setLoading(false);
    }, 1200); // efeito premium no botão :)
  }

  return (
    <>
      <Header />

      <Grid
        container
        component="main"
        sx={{
          height: "calc(100vh - 220px)",
          mt: "200px",
          mb: "20px",
          px: 2,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid item xs={12} sm={8} md={4}>
          <Paper
            elevation={8}
            sx={{
              p: 5,
              borderRadius: 4,
              background: "white",
              backdropFilter: "blur(6px)",
              boxShadow:
                "0 10px 25px rgba(0,0,0,0.15), 0 5px 10px rgba(0,0,0,0.10)",
              transition: "all .3s ease",
              "&:hover": {
                transform: "translateY(-3px)",
                boxShadow:
                  "0 12px 30px rgba(0,0,0,0.20), 0 6px 12px rgba(0,0,0,0.10)",
              },
            }}
          >
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <Avatar
                sx={{
                  width: 70,
                  height: 70,
                  margin: "auto",
                  bgcolor: "var(--azulEscuro)",
                  boxShadow: "0 4px 12px rgba(10,26,43,0.3)",
                }}
              >
                <LockOutlinedIcon sx={{ fontSize: 36 }} />
              </Avatar>

              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mt: 2,
                  color: "var(--azulEscuro)",
                  letterSpacing: "0.5px",
                }}
              >
                Painel Administrativo
              </Typography>

              <Typography
                sx={{ mt: 1, color: "#666", fontSize: 15, opacity: 0.9 }}
              >
                Faça login para continuar
              </Typography>
            </Box>

            <Box component="form" onSubmit={handleLogin}>
              <TextField
                fullWidth
                margin="normal"
                label="Usuário"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />

              <TextField
                fullWidth
                margin="normal"
                type="password"
                label="Senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading}
                sx={{
                  mt: 3,
                  py: 1.7,
                  fontSize: 16,
                  fontWeight: 600,
                  borderRadius: 2,
                  backgroundColor: "var(--azulEscuro)",
                  boxShadow: "0 5px 15px rgba(10,26,43,0.3)",
                  ":hover": {
                    backgroundColor: "#071524",
                    boxShadow: "0 8px 18px rgba(10,26,43,0.4)",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size={26} thickness={5} sx={{ color: "white" }} />
                ) : (
                  "Entrar"
                )}
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Footer />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert severity="error" variant="filled">
          {error}
        </Alert>
      </Snackbar>
    </>
  );
}
